package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Peru Flag (16x12dp)
 *
 * - ISO Alpha-2: PE
 * - ISO Alpha-3: PER
 * - ISO Numeric: 604
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.Peru: ImageVector by lazy {
    ImageVector.Builder(
        name = "Peru:PE:PER:604:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4f, 0f)
                horizontalLineTo(12.5f)
                verticalLineTo(12f)
                horizontalLineTo(4f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50101)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12f, 0f)
                horizontalLineTo(16f)
                verticalLineTo(12f)
                horizontalLineTo(12f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50101)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(4f)
                verticalLineTo(12f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA2BB6A))) {
                moveTo(7.871f, 4.373f)
                lineTo(7.887f, 4.554f)
                curveTo(7.388f, 4.604f, 7.119f, 4.36f, 7.119f, 3.854f)
                curveTo(7.119f, 3.351f, 7.382f, 3.084f, 7.879f, 3.081f)
                lineTo(7.88f, 3.263f)
                curveTo(7.478f, 3.266f, 7.292f, 3.453f, 7.292f, 3.854f)
                curveTo(7.292f, 4.251f, 7.472f, 4.413f, 7.871f, 4.373f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA2BB6A))) {
                moveTo(8.092f, 4.373f)
                lineTo(8.075f, 4.554f)
                curveTo(8.574f, 4.604f, 8.844f, 4.36f, 8.844f, 3.854f)
                curveTo(8.844f, 3.351f, 8.58f, 3.084f, 8.084f, 3.081f)
                lineTo(8.083f, 3.263f)
                curveTo(8.485f, 3.266f, 8.67f, 3.453f, 8.67f, 3.854f)
                curveTo(8.67f, 4.251f, 8.491f, 4.413f, 8.092f, 4.373f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.043f, 4.453f)
                curveTo(8.057f, 4.445f, 8.064f, 4.441f, 8.064f, 4.441f)
                verticalLineTo(4.464f)
                curveTo(8.16f, 4.517f, 8.403f, 4.642f, 8.56f, 4.642f)
                curveTo(8.761f, 4.642f, 9.033f, 4.441f, 9.033f, 4.441f)
                lineTo(9.489f, 5.084f)
                curveTo(9.489f, 5.084f, 9.182f, 5.727f, 9.417f, 6.513f)
                curveTo(9.651f, 7.299f, 9.404f, 7.905f, 8.36f, 7.972f)
                curveTo(8.36f, 7.972f, 8.154f, 8.011f, 8.064f, 8.074f)
                verticalLineTo(8.131f)
                curveTo(8.064f, 8.117f, 8.056f, 8.103f, 8.043f, 8.091f)
                curveTo(8.03f, 8.103f, 8.023f, 8.117f, 8.023f, 8.131f)
                verticalLineTo(8.074f)
                curveTo(7.933f, 8.011f, 7.727f, 7.972f, 7.727f, 7.972f)
                curveTo(6.683f, 7.905f, 6.435f, 7.299f, 6.67f, 6.513f)
                curveTo(6.905f, 5.727f, 6.598f, 5.084f, 6.598f, 5.084f)
                lineTo(7.054f, 4.441f)
                curveTo(7.054f, 4.441f, 7.326f, 4.642f, 7.526f, 4.642f)
                curveTo(7.684f, 4.642f, 7.926f, 4.517f, 8.023f, 4.464f)
                verticalLineTo(4.441f)
                curveTo(8.023f, 4.441f, 8.03f, 4.445f, 8.043f, 4.453f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(5.589f, 3.441f)
                horizontalLineToRelative(5f)
                verticalLineToRelative(6f)
                horizontalLineToRelative(-5f)
                close()
                moveTo(8.043f, 4.453f)
                curveTo(8.057f, 4.445f, 8.064f, 4.441f, 8.064f, 4.441f)
                verticalLineTo(4.464f)
                curveTo(8.16f, 4.517f, 8.403f, 4.642f, 8.56f, 4.642f)
                curveTo(8.761f, 4.642f, 9.033f, 4.441f, 9.033f, 4.441f)
                lineTo(9.489f, 5.084f)
                curveTo(9.489f, 5.084f, 9.182f, 5.727f, 9.417f, 6.513f)
                curveTo(9.651f, 7.299f, 9.404f, 7.905f, 8.36f, 7.972f)
                curveTo(8.36f, 7.972f, 8.154f, 8.011f, 8.064f, 8.074f)
                verticalLineTo(8.131f)
                curveTo(8.064f, 8.117f, 8.056f, 8.103f, 8.043f, 8.091f)
                curveTo(8.03f, 8.103f, 8.023f, 8.117f, 8.023f, 8.131f)
                verticalLineTo(8.074f)
                curveTo(7.933f, 8.011f, 7.727f, 7.972f, 7.727f, 7.972f)
                curveTo(6.683f, 7.905f, 6.435f, 7.299f, 6.67f, 6.513f)
                curveTo(6.905f, 5.727f, 6.598f, 5.084f, 6.598f, 5.084f)
                lineTo(7.054f, 4.441f)
                curveTo(7.054f, 4.441f, 7.326f, 4.642f, 7.526f, 4.642f)
                curveTo(7.684f, 4.642f, 7.926f, 4.517f, 8.023f, 4.464f)
                verticalLineTo(4.441f)
                curveTo(8.023f, 4.441f, 8.03f, 4.445f, 8.043f, 4.453f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(8.064f, 4.441f)
                horizontalLineTo(8.564f)
                verticalLineTo(3.561f)
                lineTo(7.808f, 4.011f)
                lineTo(8.064f, 4.441f)
                close()
                moveTo(8.043f, 4.453f)
                lineTo(7.797f, 4.888f)
                lineTo(8.043f, 5.027f)
                lineTo(8.29f, 4.888f)
                lineTo(8.043f, 4.453f)
                close()
                moveTo(8.064f, 4.464f)
                horizontalLineTo(7.564f)
                verticalLineTo(4.759f)
                lineTo(7.823f, 4.902f)
                lineTo(8.064f, 4.464f)
                close()
                moveTo(9.033f, 4.441f)
                lineTo(9.441f, 4.152f)
                lineTo(9.146f, 3.736f)
                lineTo(8.736f, 4.039f)
                lineTo(9.033f, 4.441f)
                close()
                moveTo(9.489f, 5.084f)
                lineTo(9.94f, 5.299f)
                lineTo(10.066f, 5.035f)
                lineTo(9.897f, 4.795f)
                lineTo(9.489f, 5.084f)
                close()
                moveTo(9.417f, 6.513f)
                lineTo(8.938f, 6.656f)
                lineTo(9.417f, 6.513f)
                close()
                moveTo(8.36f, 7.972f)
                lineTo(8.328f, 7.473f)
                lineTo(8.297f, 7.475f)
                lineTo(8.267f, 7.481f)
                lineTo(8.36f, 7.972f)
                close()
                moveTo(8.064f, 8.074f)
                lineTo(7.78f, 7.662f)
                lineTo(7.564f, 7.812f)
                verticalLineTo(8.074f)
                horizontalLineTo(8.064f)
                close()
                moveTo(8.043f, 8.091f)
                lineTo(8.394f, 7.734f)
                lineTo(8.043f, 7.39f)
                lineTo(7.693f, 7.734f)
                lineTo(8.043f, 8.091f)
                close()
                moveTo(8.023f, 8.074f)
                horizontalLineTo(8.523f)
                verticalLineTo(7.812f)
                lineTo(8.307f, 7.662f)
                lineTo(8.023f, 8.074f)
                close()
                moveTo(7.727f, 7.972f)
                lineTo(7.82f, 7.481f)
                lineTo(7.79f, 7.475f)
                lineTo(7.759f, 7.473f)
                lineTo(7.727f, 7.972f)
                close()
                moveTo(6.598f, 5.084f)
                lineTo(6.19f, 4.795f)
                lineTo(6.021f, 5.035f)
                lineTo(6.147f, 5.299f)
                lineTo(6.598f, 5.084f)
                close()
                moveTo(7.054f, 4.441f)
                lineTo(7.351f, 4.039f)
                lineTo(6.941f, 3.736f)
                lineTo(6.646f, 4.152f)
                lineTo(7.054f, 4.441f)
                close()
                moveTo(8.023f, 4.464f)
                lineTo(8.264f, 4.902f)
                lineTo(8.523f, 4.759f)
                verticalLineTo(4.464f)
                horizontalLineTo(8.023f)
                close()
                moveTo(8.023f, 4.441f)
                lineTo(8.279f, 4.011f)
                lineTo(7.523f, 3.561f)
                verticalLineTo(4.441f)
                horizontalLineTo(8.023f)
                close()
                moveTo(8.064f, 4.441f)
                curveTo(7.808f, 4.011f, 7.808f, 4.011f, 7.808f, 4.011f)
                curveTo(7.808f, 4.011f, 7.808f, 4.011f, 7.808f, 4.011f)
                curveTo(7.808f, 4.011f, 7.808f, 4.011f, 7.808f, 4.011f)
                curveTo(7.808f, 4.011f, 7.808f, 4.011f, 7.808f, 4.011f)
                curveTo(7.808f, 4.011f, 7.808f, 4.011f, 7.808f, 4.011f)
                curveTo(7.808f, 4.011f, 7.808f, 4.011f, 7.809f, 4.011f)
                curveTo(7.809f, 4.011f, 7.809f, 4.011f, 7.809f, 4.011f)
                curveTo(7.809f, 4.011f, 7.809f, 4.011f, 7.809f, 4.011f)
                curveTo(7.809f, 4.011f, 7.808f, 4.011f, 7.807f, 4.012f)
                curveTo(7.805f, 4.013f, 7.802f, 4.015f, 7.797f, 4.018f)
                lineTo(8.29f, 4.888f)
                curveTo(8.298f, 4.883f, 8.305f, 4.879f, 8.31f, 4.876f)
                curveTo(8.313f, 4.874f, 8.315f, 4.873f, 8.317f, 4.872f)
                curveTo(8.317f, 4.872f, 8.318f, 4.871f, 8.319f, 4.871f)
                curveTo(8.319f, 4.871f, 8.319f, 4.871f, 8.32f, 4.871f)
                curveTo(8.32f, 4.871f, 8.32f, 4.87f, 8.32f, 4.87f)
                curveTo(8.32f, 4.87f, 8.32f, 4.87f, 8.32f, 4.87f)
                curveTo(8.32f, 4.87f, 8.32f, 4.87f, 8.32f, 4.87f)
                curveTo(8.32f, 4.87f, 8.32f, 4.87f, 8.32f, 4.87f)
                curveTo(8.32f, 4.87f, 8.32f, 4.87f, 8.32f, 4.87f)
                curveTo(8.32f, 4.87f, 8.32f, 4.87f, 8.064f, 4.441f)
                close()
                moveTo(8.564f, 4.464f)
                verticalLineTo(4.441f)
                horizontalLineTo(7.564f)
                verticalLineTo(4.464f)
                horizontalLineTo(8.564f)
                close()
                moveTo(7.823f, 4.902f)
                curveTo(7.879f, 4.933f, 7.983f, 4.988f, 8.1f, 5.036f)
                curveTo(8.201f, 5.077f, 8.378f, 5.142f, 8.56f, 5.142f)
                verticalLineTo(4.142f)
                curveTo(8.581f, 4.142f, 8.583f, 4.145f, 8.56f, 4.139f)
                curveTo(8.54f, 4.133f, 8.512f, 4.124f, 8.478f, 4.11f)
                curveTo(8.411f, 4.083f, 8.345f, 4.048f, 8.306f, 4.027f)
                lineTo(7.823f, 4.902f)
                close()
                moveTo(8.56f, 5.142f)
                curveTo(8.794f, 5.142f, 9.007f, 5.036f, 9.109f, 4.981f)
                curveTo(9.172f, 4.948f, 9.225f, 4.914f, 9.262f, 4.89f)
                curveTo(9.281f, 4.877f, 9.297f, 4.867f, 9.308f, 4.859f)
                curveTo(9.314f, 4.855f, 9.319f, 4.851f, 9.322f, 4.849f)
                curveTo(9.324f, 4.847f, 9.326f, 4.846f, 9.327f, 4.845f)
                curveTo(9.328f, 4.845f, 9.328f, 4.844f, 9.329f, 4.844f)
                curveTo(9.329f, 4.844f, 9.329f, 4.844f, 9.329f, 4.843f)
                curveTo(9.33f, 4.843f, 9.33f, 4.843f, 9.33f, 4.843f)
                curveTo(9.33f, 4.843f, 9.33f, 4.843f, 9.33f, 4.843f)
                curveTo(9.33f, 4.843f, 9.33f, 4.843f, 9.033f, 4.441f)
                curveTo(8.736f, 4.039f, 8.736f, 4.038f, 8.736f, 4.038f)
                curveTo(8.736f, 4.038f, 8.736f, 4.038f, 8.736f, 4.038f)
                curveTo(8.736f, 4.038f, 8.736f, 4.038f, 8.736f, 4.038f)
                curveTo(8.737f, 4.038f, 8.737f, 4.038f, 8.737f, 4.038f)
                curveTo(8.737f, 4.038f, 8.737f, 4.038f, 8.737f, 4.037f)
                curveTo(8.738f, 4.037f, 8.738f, 4.037f, 8.738f, 4.037f)
                curveTo(8.737f, 4.038f, 8.736f, 4.039f, 8.734f, 4.04f)
                curveTo(8.73f, 4.043f, 8.722f, 4.048f, 8.713f, 4.054f)
                curveTo(8.693f, 4.068f, 8.665f, 4.085f, 8.634f, 4.101f)
                curveTo(8.603f, 4.118f, 8.575f, 4.131f, 8.553f, 4.139f)
                curveTo(8.528f, 4.147f, 8.533f, 4.142f, 8.56f, 4.142f)
                verticalLineTo(5.142f)
                close()
                moveTo(8.625f, 4.73f)
                lineTo(9.081f, 5.373f)
                lineTo(9.897f, 4.795f)
                lineTo(9.441f, 4.152f)
                lineTo(8.625f, 4.73f)
                close()
                moveTo(9.489f, 5.084f)
                curveTo(9.037f, 4.869f, 9.037f, 4.869f, 9.037f, 4.869f)
                curveTo(9.037f, 4.869f, 9.037f, 4.869f, 9.037f, 4.87f)
                curveTo(9.037f, 4.87f, 9.037f, 4.87f, 9.037f, 4.87f)
                curveTo(9.036f, 4.871f, 9.036f, 4.871f, 9.036f, 4.872f)
                curveTo(9.035f, 4.873f, 9.035f, 4.875f, 9.034f, 4.876f)
                curveTo(9.032f, 4.879f, 9.031f, 4.883f, 9.029f, 4.888f)
                curveTo(9.025f, 4.896f, 9.02f, 4.908f, 9.014f, 4.922f)
                curveTo(9.003f, 4.949f, 8.988f, 4.987f, 8.972f, 5.033f)
                curveTo(8.94f, 5.126f, 8.902f, 5.256f, 8.873f, 5.414f)
                curveTo(8.815f, 5.729f, 8.792f, 6.169f, 8.938f, 6.656f)
                lineTo(9.896f, 6.37f)
                curveTo(9.806f, 6.071f, 9.819f, 5.797f, 9.856f, 5.594f)
                curveTo(9.875f, 5.493f, 9.899f, 5.413f, 9.917f, 5.36f)
                curveTo(9.926f, 5.334f, 9.933f, 5.315f, 9.938f, 5.305f)
                curveTo(9.94f, 5.3f, 9.941f, 5.296f, 9.942f, 5.295f)
                curveTo(9.942f, 5.295f, 9.942f, 5.295f, 9.942f, 5.296f)
                curveTo(9.942f, 5.296f, 9.941f, 5.297f, 9.941f, 5.297f)
                curveTo(9.941f, 5.297f, 9.941f, 5.298f, 9.941f, 5.298f)
                curveTo(9.94f, 5.298f, 9.94f, 5.299f, 9.94f, 5.299f)
                curveTo(9.94f, 5.299f, 9.94f, 5.299f, 9.94f, 5.299f)
                curveTo(9.94f, 5.299f, 9.94f, 5.299f, 9.489f, 5.084f)
                close()
                moveTo(8.938f, 6.656f)
                curveTo(9.036f, 6.987f, 8.997f, 7.163f, 8.945f, 7.245f)
                curveTo(8.902f, 7.314f, 8.767f, 7.445f, 8.328f, 7.473f)
                lineTo(8.392f, 8.471f)
                curveTo(8.997f, 8.432f, 9.508f, 8.227f, 9.791f, 7.779f)
                curveTo(10.065f, 7.345f, 10.032f, 6.825f, 9.896f, 6.37f)
                lineTo(8.938f, 6.656f)
                close()
                moveTo(8.36f, 7.972f)
                curveTo(8.267f, 7.481f, 8.267f, 7.481f, 8.267f, 7.481f)
                curveTo(8.267f, 7.481f, 8.267f, 7.481f, 8.266f, 7.481f)
                curveTo(8.266f, 7.481f, 8.266f, 7.481f, 8.266f, 7.481f)
                curveTo(8.266f, 7.481f, 8.266f, 7.481f, 8.266f, 7.481f)
                curveTo(8.265f, 7.481f, 8.265f, 7.481f, 8.264f, 7.482f)
                curveTo(8.263f, 7.482f, 8.262f, 7.482f, 8.261f, 7.482f)
                curveTo(8.258f, 7.483f, 8.255f, 7.483f, 8.25f, 7.484f)
                curveTo(8.242f, 7.486f, 8.231f, 7.488f, 8.217f, 7.492f)
                curveTo(8.19f, 7.498f, 8.153f, 7.506f, 8.111f, 7.518f)
                curveTo(8.048f, 7.536f, 7.901f, 7.579f, 7.78f, 7.662f)
                lineTo(8.348f, 8.485f)
                curveTo(8.325f, 8.502f, 8.313f, 8.504f, 8.33f, 8.498f)
                curveTo(8.341f, 8.493f, 8.359f, 8.487f, 8.381f, 8.481f)
                curveTo(8.402f, 8.475f, 8.421f, 8.471f, 8.436f, 8.467f)
                curveTo(8.443f, 8.466f, 8.448f, 8.465f, 8.452f, 8.464f)
                curveTo(8.453f, 8.464f, 8.454f, 8.463f, 8.454f, 8.463f)
                curveTo(8.455f, 8.463f, 8.455f, 8.463f, 8.454f, 8.463f)
                curveTo(8.454f, 8.463f, 8.454f, 8.463f, 8.454f, 8.463f)
                curveTo(8.454f, 8.463f, 8.454f, 8.463f, 8.454f, 8.463f)
                curveTo(8.454f, 8.463f, 8.454f, 8.464f, 8.454f, 8.464f)
                curveTo(8.454f, 8.464f, 8.453f, 8.464f, 8.453f, 8.464f)
                curveTo(8.453f, 8.464f, 8.453f, 8.464f, 8.36f, 7.972f)
                close()
                moveTo(8.564f, 8.131f)
                verticalLineTo(8.074f)
                horizontalLineTo(7.564f)
                verticalLineTo(8.131f)
                horizontalLineTo(8.564f)
                close()
                moveTo(7.693f, 8.448f)
                curveTo(7.658f, 8.413f, 7.564f, 8.306f, 7.564f, 8.131f)
                horizontalLineTo(8.564f)
                curveTo(8.564f, 7.928f, 8.455f, 7.794f, 8.394f, 7.734f)
                lineTo(7.693f, 8.448f)
                close()
                moveTo(7.693f, 7.734f)
                curveTo(7.632f, 7.794f, 7.523f, 7.928f, 7.523f, 8.131f)
                horizontalLineTo(8.523f)
                curveTo(8.523f, 8.306f, 8.429f, 8.413f, 8.394f, 8.448f)
                lineTo(7.693f, 7.734f)
                close()
                moveTo(8.523f, 8.131f)
                verticalLineTo(8.074f)
                horizontalLineTo(7.523f)
                verticalLineTo(8.131f)
                horizontalLineTo(8.523f)
                close()
                moveTo(7.727f, 7.972f)
                curveTo(7.633f, 8.464f, 7.633f, 8.464f, 7.633f, 8.464f)
                curveTo(7.633f, 8.464f, 7.633f, 8.464f, 7.633f, 8.464f)
                curveTo(7.633f, 8.464f, 7.633f, 8.463f, 7.633f, 8.463f)
                curveTo(7.633f, 8.463f, 7.633f, 8.463f, 7.633f, 8.463f)
                curveTo(7.633f, 8.463f, 7.632f, 8.463f, 7.632f, 8.463f)
                curveTo(7.632f, 8.463f, 7.632f, 8.463f, 7.632f, 8.463f)
                curveTo(7.633f, 8.463f, 7.634f, 8.464f, 7.635f, 8.464f)
                curveTo(7.638f, 8.465f, 7.644f, 8.466f, 7.651f, 8.467f)
                curveTo(7.666f, 8.471f, 7.685f, 8.475f, 7.706f, 8.481f)
                curveTo(7.728f, 8.487f, 7.745f, 8.493f, 7.757f, 8.498f)
                curveTo(7.774f, 8.504f, 7.762f, 8.502f, 7.738f, 8.485f)
                lineTo(8.307f, 7.662f)
                curveTo(8.186f, 7.579f, 8.038f, 7.536f, 7.976f, 7.518f)
                curveTo(7.934f, 7.506f, 7.897f, 7.498f, 7.87f, 7.492f)
                curveTo(7.856f, 7.488f, 7.845f, 7.486f, 7.836f, 7.484f)
                curveTo(7.832f, 7.483f, 7.829f, 7.483f, 7.826f, 7.482f)
                curveTo(7.825f, 7.482f, 7.823f, 7.482f, 7.822f, 7.482f)
                curveTo(7.822f, 7.481f, 7.821f, 7.481f, 7.821f, 7.481f)
                curveTo(7.821f, 7.481f, 7.821f, 7.481f, 7.821f, 7.481f)
                curveTo(7.82f, 7.481f, 7.82f, 7.481f, 7.82f, 7.481f)
                curveTo(7.82f, 7.481f, 7.82f, 7.481f, 7.82f, 7.481f)
                curveTo(7.82f, 7.481f, 7.82f, 7.481f, 7.727f, 7.972f)
                close()
                moveTo(6.191f, 6.37f)
                curveTo(6.055f, 6.825f, 6.022f, 7.345f, 6.296f, 7.779f)
                curveTo(6.579f, 8.227f, 7.09f, 8.432f, 7.695f, 8.471f)
                lineTo(7.759f, 7.473f)
                curveTo(7.319f, 7.445f, 7.185f, 7.314f, 7.142f, 7.245f)
                curveTo(7.09f, 7.163f, 7.051f, 6.987f, 7.149f, 6.656f)
                lineTo(6.191f, 6.37f)
                close()
                moveTo(6.598f, 5.084f)
                curveTo(6.147f, 5.299f, 6.147f, 5.299f, 6.147f, 5.299f)
                curveTo(6.147f, 5.299f, 6.147f, 5.299f, 6.147f, 5.299f)
                curveTo(6.146f, 5.299f, 6.146f, 5.298f, 6.146f, 5.298f)
                curveTo(6.146f, 5.298f, 6.146f, 5.297f, 6.146f, 5.297f)
                curveTo(6.146f, 5.297f, 6.145f, 5.296f, 6.145f, 5.296f)
                curveTo(6.145f, 5.295f, 6.145f, 5.295f, 6.145f, 5.295f)
                curveTo(6.145f, 5.296f, 6.147f, 5.3f, 6.149f, 5.305f)
                curveTo(6.153f, 5.315f, 6.161f, 5.334f, 6.17f, 5.36f)
                curveTo(6.188f, 5.413f, 6.212f, 5.493f, 6.23f, 5.594f)
                curveTo(6.267f, 5.797f, 6.28f, 6.071f, 6.191f, 6.37f)
                lineTo(7.149f, 6.656f)
                curveTo(7.295f, 6.169f, 7.272f, 5.729f, 7.214f, 5.414f)
                curveTo(7.185f, 5.256f, 7.147f, 5.126f, 7.115f, 5.033f)
                curveTo(7.099f, 4.987f, 7.084f, 4.949f, 7.073f, 4.922f)
                curveTo(7.067f, 4.908f, 7.062f, 4.896f, 7.058f, 4.888f)
                curveTo(7.056f, 4.883f, 7.054f, 4.879f, 7.053f, 4.876f)
                curveTo(7.052f, 4.875f, 7.052f, 4.873f, 7.051f, 4.872f)
                curveTo(7.051f, 4.871f, 7.05f, 4.871f, 7.05f, 4.87f)
                curveTo(7.05f, 4.87f, 7.05f, 4.87f, 7.05f, 4.87f)
                curveTo(7.05f, 4.869f, 7.05f, 4.869f, 7.05f, 4.869f)
                curveTo(7.049f, 4.869f, 7.049f, 4.869f, 6.598f, 5.084f)
                close()
                moveTo(6.646f, 4.152f)
                lineTo(6.19f, 4.795f)
                lineTo(7.006f, 5.373f)
                lineTo(7.462f, 4.73f)
                lineTo(6.646f, 4.152f)
                close()
                moveTo(7.526f, 4.142f)
                curveTo(7.554f, 4.142f, 7.559f, 4.147f, 7.534f, 4.139f)
                curveTo(7.512f, 4.131f, 7.484f, 4.118f, 7.453f, 4.101f)
                curveTo(7.422f, 4.085f, 7.394f, 4.068f, 7.374f, 4.054f)
                curveTo(7.365f, 4.048f, 7.357f, 4.043f, 7.353f, 4.04f)
                curveTo(7.351f, 4.039f, 7.35f, 4.038f, 7.349f, 4.037f)
                curveTo(7.349f, 4.037f, 7.349f, 4.037f, 7.349f, 4.037f)
                curveTo(7.349f, 4.038f, 7.35f, 4.038f, 7.35f, 4.038f)
                curveTo(7.35f, 4.038f, 7.35f, 4.038f, 7.35f, 4.038f)
                curveTo(7.35f, 4.038f, 7.35f, 4.038f, 7.351f, 4.038f)
                curveTo(7.351f, 4.038f, 7.351f, 4.038f, 7.351f, 4.038f)
                curveTo(7.351f, 4.038f, 7.351f, 4.039f, 7.054f, 4.441f)
                curveTo(6.757f, 4.843f, 6.757f, 4.843f, 6.757f, 4.843f)
                curveTo(6.757f, 4.843f, 6.757f, 4.843f, 6.757f, 4.843f)
                curveTo(6.757f, 4.843f, 6.757f, 4.843f, 6.757f, 4.843f)
                curveTo(6.758f, 4.844f, 6.758f, 4.844f, 6.758f, 4.844f)
                curveTo(6.759f, 4.844f, 6.759f, 4.845f, 6.76f, 4.845f)
                curveTo(6.761f, 4.846f, 6.763f, 4.847f, 6.765f, 4.849f)
                curveTo(6.768f, 4.851f, 6.773f, 4.855f, 6.779f, 4.859f)
                curveTo(6.79f, 4.867f, 6.806f, 4.877f, 6.825f, 4.89f)
                curveTo(6.862f, 4.914f, 6.915f, 4.948f, 6.977f, 4.981f)
                curveTo(7.079f, 5.036f, 7.293f, 5.142f, 7.526f, 5.142f)
                verticalLineTo(4.142f)
                close()
                moveTo(7.781f, 4.027f)
                curveTo(7.742f, 4.048f, 7.676f, 4.083f, 7.608f, 4.11f)
                curveTo(7.575f, 4.124f, 7.547f, 4.133f, 7.527f, 4.139f)
                curveTo(7.503f, 4.145f, 7.506f, 4.142f, 7.526f, 4.142f)
                verticalLineTo(5.142f)
                curveTo(7.709f, 5.142f, 7.885f, 5.077f, 7.987f, 5.036f)
                curveTo(8.104f, 4.988f, 8.207f, 4.933f, 8.264f, 4.902f)
                lineTo(7.781f, 4.027f)
                close()
                moveTo(8.523f, 4.464f)
                verticalLineTo(4.441f)
                horizontalLineTo(7.523f)
                verticalLineTo(4.464f)
                horizontalLineTo(8.523f)
                close()
                moveTo(8.023f, 4.441f)
                curveTo(7.767f, 4.87f, 7.767f, 4.87f, 7.767f, 4.87f)
                curveTo(7.767f, 4.87f, 7.767f, 4.87f, 7.767f, 4.87f)
                curveTo(7.767f, 4.87f, 7.767f, 4.87f, 7.767f, 4.87f)
                curveTo(7.767f, 4.87f, 7.767f, 4.87f, 7.767f, 4.87f)
                curveTo(7.767f, 4.87f, 7.767f, 4.87f, 7.767f, 4.87f)
                curveTo(7.767f, 4.87f, 7.767f, 4.871f, 7.767f, 4.871f)
                curveTo(7.767f, 4.871f, 7.768f, 4.871f, 7.768f, 4.871f)
                curveTo(7.769f, 4.871f, 7.769f, 4.872f, 7.77f, 4.872f)
                curveTo(7.772f, 4.873f, 7.774f, 4.874f, 7.776f, 4.876f)
                curveTo(7.782f, 4.879f, 7.788f, 4.883f, 7.797f, 4.888f)
                lineTo(8.29f, 4.018f)
                curveTo(8.285f, 4.015f, 8.282f, 4.013f, 8.28f, 4.012f)
                curveTo(8.279f, 4.011f, 8.278f, 4.011f, 8.278f, 4.011f)
                curveTo(8.278f, 4.011f, 8.278f, 4.011f, 8.278f, 4.011f)
                curveTo(8.278f, 4.011f, 8.278f, 4.011f, 8.278f, 4.011f)
                curveTo(8.278f, 4.011f, 8.278f, 4.011f, 8.278f, 4.011f)
                curveTo(8.278f, 4.011f, 8.279f, 4.011f, 8.279f, 4.011f)
                curveTo(8.279f, 4.011f, 8.279f, 4.011f, 8.279f, 4.011f)
                curveTo(8.279f, 4.011f, 8.279f, 4.011f, 8.279f, 4.011f)
                curveTo(8.279f, 4.011f, 8.279f, 4.011f, 8.279f, 4.011f)
                curveTo(8.279f, 4.011f, 8.279f, 4.011f, 8.023f, 4.441f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(5.589f, 3.441f)
                horizontalLineToRelative(5f)
                verticalLineToRelative(6f)
                horizontalLineToRelative(-5f)
                close()
                moveTo(8.043f, 4.453f)
                curveTo(8.057f, 4.445f, 8.064f, 4.441f, 8.064f, 4.441f)
                verticalLineTo(4.464f)
                curveTo(8.16f, 4.517f, 8.403f, 4.642f, 8.56f, 4.642f)
                curveTo(8.761f, 4.642f, 9.033f, 4.441f, 9.033f, 4.441f)
                lineTo(9.489f, 5.084f)
                curveTo(9.489f, 5.084f, 9.182f, 5.727f, 9.417f, 6.513f)
                curveTo(9.651f, 7.299f, 9.404f, 7.905f, 8.36f, 7.972f)
                curveTo(8.36f, 7.972f, 8.154f, 8.011f, 8.064f, 8.074f)
                verticalLineTo(8.131f)
                curveTo(8.064f, 8.117f, 8.056f, 8.103f, 8.043f, 8.091f)
                curveTo(8.03f, 8.103f, 8.023f, 8.117f, 8.023f, 8.131f)
                verticalLineTo(8.074f)
                curveTo(7.933f, 8.011f, 7.727f, 7.972f, 7.727f, 7.972f)
                curveTo(6.683f, 7.905f, 6.435f, 7.299f, 6.67f, 6.513f)
                curveTo(6.905f, 5.727f, 6.598f, 5.084f, 6.598f, 5.084f)
                lineTo(7.054f, 4.441f)
                curveTo(7.054f, 4.441f, 7.326f, 4.642f, 7.526f, 4.642f)
                curveTo(7.684f, 4.642f, 7.926f, 4.517f, 8.023f, 4.464f)
                verticalLineTo(4.441f)
                curveTo(8.023f, 4.441f, 8.03f, 4.445f, 8.043f, 4.453f)
                close()
                moveTo(8.043f, 4.453f)
                curveTo(8.057f, 4.445f, 8.064f, 4.441f, 8.064f, 4.441f)
                verticalLineTo(4.464f)
                curveTo(8.16f, 4.517f, 8.403f, 4.642f, 8.56f, 4.642f)
                curveTo(8.761f, 4.642f, 9.033f, 4.441f, 9.033f, 4.441f)
                lineTo(9.489f, 5.084f)
                curveTo(9.489f, 5.084f, 9.182f, 5.727f, 9.417f, 6.513f)
                curveTo(9.651f, 7.299f, 9.404f, 7.905f, 8.36f, 7.972f)
                curveTo(8.36f, 7.972f, 8.154f, 8.011f, 8.064f, 8.074f)
                verticalLineTo(8.131f)
                curveTo(8.064f, 8.117f, 8.056f, 8.103f, 8.043f, 8.091f)
                curveTo(8.03f, 8.103f, 8.023f, 8.117f, 8.023f, 8.131f)
                verticalLineTo(8.074f)
                curveTo(7.933f, 8.011f, 7.727f, 7.972f, 7.727f, 7.972f)
                curveTo(6.683f, 7.905f, 6.435f, 7.299f, 6.67f, 6.513f)
                curveTo(6.905f, 5.727f, 6.598f, 5.084f, 6.598f, 5.084f)
                lineTo(7.054f, 4.441f)
                curveTo(7.054f, 4.441f, 7.326f, 4.642f, 7.526f, 4.642f)
                curveTo(7.684f, 4.642f, 7.926f, 4.517f, 8.023f, 4.464f)
                verticalLineTo(4.441f)
                curveTo(8.023f, 4.441f, 8.03f, 4.445f, 8.043f, 4.453f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF67BAFF))) {
                moveTo(6.652f, 4.364f)
                horizontalLineToRelative(1.391f)
                verticalLineToRelative(1.909f)
                horizontalLineToRelative(-1.391f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(8.043f, 4.364f)
                horizontalLineToRelative(1.391f)
                verticalLineToRelative(1.909f)
                horizontalLineToRelative(-1.391f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC51918))) {
                moveTo(6.478f, 6.455f)
                horizontalLineToRelative(3.478f)
                verticalLineToRelative(2.182f)
                horizontalLineToRelative(-3.478f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(8.717f, 6.137f)
                horizontalLineTo(8.543f)
                verticalLineTo(4.83f)
                horizontalLineTo(8.717f)
                verticalLineTo(6.137f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(8.647f, 5.543f)
                lineTo(8.562f, 5.695f)
                lineTo(8.262f, 5.527f)
                lineTo(8.347f, 5.375f)
                lineTo(8.647f, 5.543f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(8.647f, 5.179f)
                lineTo(8.562f, 5.331f)
                lineTo(8.262f, 5.163f)
                lineTo(8.347f, 5.012f)
                lineTo(8.647f, 5.179f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(8.61f, 5.543f)
                lineTo(8.695f, 5.695f)
                lineTo(8.995f, 5.527f)
                lineTo(8.91f, 5.375f)
                lineTo(8.61f, 5.543f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(8.61f, 5.179f)
                lineTo(8.695f, 5.331f)
                lineTo(8.995f, 5.163f)
                lineTo(8.91f, 5.012f)
                lineTo(8.61f, 5.179f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFD18219)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.688f, 4.785f)
                curveTo(7.583f, 4.877f, 7.651f, 5.212f, 7.479f, 5.212f)
                curveTo(7.307f, 5.212f, 7.066f, 4.961f, 7.005f, 5.126f)
                curveTo(6.944f, 5.292f, 7.005f, 5.236f, 7.005f, 5.377f)
                curveTo(7.005f, 5.518f, 6.859f, 5.91f, 6.932f, 5.976f)
                curveTo(7.005f, 6.043f, 7.079f, 6.217f, 7.066f, 6.136f)
                curveTo(7.054f, 6.054f, 6.998f, 5.934f, 7.021f, 5.803f)
                curveTo(6.999f, 5.669f, 7.144f, 5.539f, 7.144f, 5.539f)
                curveTo(7.144f, 5.539f, 7.128f, 5.679f, 7.117f, 5.731f)
                curveTo(7.117f, 5.731f, 7.069f, 5.836f, 7.089f, 5.906f)
                curveTo(7.089f, 5.906f, 7.138f, 6.103f, 7.158f, 6.117f)
                curveTo(7.158f, 6.117f, 7.171f, 5.651f, 7.186f, 5.574f)
                curveTo(7.201f, 5.497f, 7.308f, 5.66f, 7.343f, 5.642f)
                curveTo(7.343f, 5.642f, 7.355f, 5.961f, 7.337f, 5.999f)
                curveTo(7.337f, 5.999f, 7.299f, 6.074f, 7.313f, 6.098f)
                curveTo(7.313f, 6.098f, 7.348f, 6.186f, 7.378f, 6.16f)
                curveTo(7.378f, 6.16f, 7.379f, 6.158f, 7.394f, 6.073f)
                curveTo(7.394f, 6.073f, 7.376f, 6.022f, 7.404f, 5.905f)
                curveTo(7.404f, 5.905f, 7.432f, 5.648f, 7.444f, 5.704f)
                curveTo(7.444f, 5.704f, 7.439f, 5.825f, 7.453f, 5.888f)
                curveTo(7.453f, 5.888f, 7.474f, 6.043f, 7.479f, 6.06f)
                curveTo(7.479f, 6.06f, 7.584f, 6.21f, 7.587f, 6.147f)
                curveTo(7.587f, 6.147f, 7.486f, 6.027f, 7.507f, 5.935f)
                curveTo(7.507f, 5.935f, 7.45f, 5.677f, 7.53f, 5.619f)
                curveTo(7.53f, 5.619f, 7.744f, 5.52f, 7.756f, 5.352f)
                curveTo(7.756f, 5.352f, 7.787f, 5.159f, 7.793f, 5.071f)
                curveTo(7.793f, 5.071f, 7.746f, 5.045f, 7.843f, 4.999f)
                curveTo(7.843f, 4.999f, 7.998f, 4.94f, 7.901f, 4.856f)
            }
        }
        path(fill = SolidColor(Color(0xFF00A854))) {
            moveTo(6.1f, 3.843f)
            lineTo(6.487f, 4.153f)
            curveTo(5.983f, 4.982f, 6.1f, 5.762f, 6.1f, 6.263f)
            curveTo(6.1f, 7.188f, 6.795f, 8.255f, 8.005f, 8.255f)
            curveTo(8.905f, 8.255f, 9.883f, 7.555f, 10.114f, 6.699f)
            curveTo(10.295f, 6.025f, 9.878f, 4.442f, 9.564f, 4.029f)
            lineTo(9.936f, 3.843f)
            curveTo(10.424f, 4.485f, 11.35f, 5.954f, 11.079f, 6.959f)
            curveTo(10.727f, 8.265f, 9.344f, 9.255f, 8.005f, 9.255f)
            curveTo(6.13f, 9.255f, 5.1f, 7.673f, 5.1f, 6.263f)
            curveTo(5.1f, 5.547f, 5.51f, 4.814f, 6.1f, 3.843f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFDD200)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(8f, 7.6f)
            curveTo(8.552f, 7.6f, 9f, 7.376f, 9f, 7.1f)
            curveTo(9f, 6.824f, 8.552f, 6.6f, 8f, 6.6f)
            curveTo(7.448f, 6.6f, 7f, 6.824f, 7f, 7.1f)
            curveTo(7f, 7.376f, 7.448f, 7.6f, 8f, 7.6f)
            close()
        }
        path(fill = SolidColor(Color(0xFFCA0000))) {
            moveTo(6.5f, 8f)
            horizontalLineToRelative(3f)
            verticalLineToRelative(1f)
            horizontalLineToRelative(-3f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun PeruPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.Peru,
            contentDescription = "Peru Flag"
        )
    }
}
